module.exports = __webpack_public_path__ + "img/file-medical-alt.d509816d.svg";